import { Icon } from 'ui/components';

export type TCategoriesIcons = {
  name: string;
  icon: JSX.Element;
  tagName?: string;
  slugName?: string;
  isNew?: boolean;
};

const categoriesViewbox = {
  default: '0 0 40 40',
  launch: '0 0 30 40',
};

export const categoriesIcons = [
  {
    name: 'Promoções',
    icon: <Icon.PromotionCategory viewBox={categoriesViewbox.default} />,
    tagName: 'discount',
    isNew: true,
  },
  {
    name: 'Perfumaria',
    icon: <Icon.PerfurmeCategory viewBox={categoriesViewbox.default} />,
    slugName: 'perfumaria',
  },
  {
    name: 'Corpo e banho',
    icon: <Icon.BodyAndBathCategory viewBox={categoriesViewbox.default} />,
    slugName: 'corpo-e-banho',
  },
  {
    name: 'Cabelos',
    icon: <Icon.HairCategory viewBox={categoriesViewbox.default} />,
    slugName: 'cabelos',
  },
  {
    name: 'Maquiagem',
    icon: <Icon.MakeUpCategory viewBox={categoriesViewbox.default} />,
    slugName: 'maquiagem',
  },
  {
    name: 'Cuidados para pele',
    icon: <Icon.SkincareCategoryIcon />,
    slugName: 'cuidados-para-pele',
  },
  {
    name: 'Bem Estar & Saúde',
    icon: <Icon.HouseAndPetsCategory viewBox={categoriesViewbox.default} />,
    slugName: 'bem-estar-e-saude',
  },
  {
    name: 'Lançamentos',
    icon: <Icon.LaunchCategory viewBox={categoriesViewbox.launch} />,
    tagName: 'launch',
  },
  {
    name: 'Selecionados para você',
    icon: <Icon.SelectedForYouCategory viewBox={categoriesViewbox.default} />,
    tagName: 'recommendation',
  },
] as TCategoriesIcons[];
